var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilestoneLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384,
    height: 48,
    viewBox: "0 0 384 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    transform: "translate(23707.5 481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    d: "M0,0H384",
    transform: "translate(-23707.5 -457)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474",
    transform: "translate(-23539.5 -481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    fill: "#fff",
    stroke: "#dc7236",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23-2",
    "data-name": "Ellipse 23",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#dc7236"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneLine);
export default __webpack_public_path__ + "static/media/milestone-line.62318d2c1a8e8a1e1889d545f3a8a662.svg";
export { ForwardRef as ReactComponent };